const Style = {
   container: 'flex h-full overflow-hidden w-full',
   content: 'flex flex-col h-full px-4 overflow-x-hidden w-full',
   top: 'flex justify-center items-center',
   divider: 'mt-4 border-t border-main-300/50',
   status: 'flex space-x-6 px-4 h-full min-h-[350px] bg-main-100/10 shadow-inner overflow-auto',
}

export default Style;